import React from "react"
import {useSelector, useDispatch} from "react-redux"
import {Transition} from "react-transition-group"

import RightWorkBtn from "./RightWorkBtn"
import HoveredBtn from "./HoveredBtn"
import {
  clearLeftWorkAreaState,
  clearActiveObject,
  clearActiveObjects,
} from "../../redux/actions/product2dActions"

import "./rightworkarea.scss"

/**
 * Right working area with functions for working with active objects on the canvas
 * @component
 * @example
 * return (
 *  <RightWorkArea />
 * )
 */

const RightWorkArea = () => {
  const makFabric = useSelector(state => state.makFabric)
  const activeObj = useSelector(state => state.activeObj)
  const activeObjs = useSelector(state => state.activeObjs)
  const dispatch = useDispatch()

  // console.log(makFabric && activeObjs, activeObj)

  /**
   * Function to start the operation with object
   * @param {object} e - element
   * @param {object} e.target - target element
   * @param {string} e.target.name - target element
   */
  const actionHandler = ({target}) => {
    switch (target.name) {
      case "DELETE":
        makFabric.removeObjects()
        dispatch(clearLeftWorkAreaState())
        dispatch(clearActiveObject())
        dispatch(clearActiveObjects())
        break
      case "DUPLICATE":
        makFabric.copyObject(activeObj)
        break
      case "REPEAT":
        makFabric.repeatObject(activeObj)
        break
      case "FLIPH":
        makFabric.flipXObjects()
        break
      case "FLIPV":
        makFabric.flipYObjects()
        break
      case "ALIGNL":
        makFabric.alignObjects("LEFT")
        break
      case "ALIGNR":
        makFabric.alignObjects("RIGHT")
        break
      case "ALIGNC":
        makFabric.alignObjects("CENTER")
        break
      case "ALIGNT":
        makFabric.alignObjects("TOP")
        break
      case "ALIGNB":
        makFabric.alignObjects("BOTTOM")
        break
      case "BRINGTOFRONT":
        makFabric.bringToFrontObjs()
        break
      case "SENDTOBACK":
        makFabric.sendToBackObjs()
        break
      default:
        return
    }
  }

  const renderBtns = () => (
    <React.Fragment>
      {btnSettings.map(item => (
        <RightWorkBtn
          key={`_key${item.label}$`}
          label={item.label}
          name={item.name}
          icon={item.icon}
          handler={actionHandler}
          disabled={
            (item.forOne && activeObjs.length > 1) ||
            (item.forOne && activeObj && activeObj.type === "rect")
          }
          style={
            (item.forOne && activeObjs.length > 1) ||
            (item.forOne && activeObj && activeObj.type === "rect")
              ? {opacity: 0.6}
              : {opacity: 1}
          }
        />
      ))}
      {combineOptions.map(item => (
        <HoveredBtn
          key={`_key${item.label}$`}
          icon={item.icon}
          label={item.label}
          btns={item.btns}
          activeObjs={activeObjs}
          activeObj={activeObj}
          actionHandler={actionHandler}
        />
      ))}
    </React.Fragment>
  )

  return (
    <div className="rightWorkAreaContainer">
      <Transition
        in={activeObj || activeObjs.length ? true : false}
        timeout={200}
        unmountOnExit={true}
      >
        {state => (
          <div style={{...defSt, ...transSt[state]}}>{renderBtns()}</div>
        )}
      </Transition>
    </div>
  )
}

export default RightWorkArea

const btnSettings = [
  {name: "DELETE", label: "Delete", icon: "/assets/img/icons/trash_icn.svg"},
  {
    name: "DUPLICATE",
    label: "Duplicate",
    icon: "/assets/img/icons/copy_icn.svg",
    forOne: true,
  },
  {
    name: "REPEAT",
    label: "Repeat",
    icon: "/assets/img/icons/copy_icn.svg",
    forOne: true,
  },
]

const combineOptions = [
  {
    label: "Flip",
    icon: "/assets/img/icons/flip_h.svg",
    btns: [
      {name: "FLIPH", label: "Flip H", icon: "/assets/img/icons/flip_h.svg"},
      {name: "FLIPV", label: "Flip V", icon: "/assets/img/icons/flip_v.svg"},
    ],
  },
  {
    label: "Alignment",
    icon: "/assets/img/icons/align_c.svg",
    btns: [
      {
        name: "ALIGNL",
        label: "Align left",
        icon: "/assets/img/icons/align_l.svg",
      },
      {
        name: "ALIGNR",
        label: "Align right",
        icon: "/assets/img/icons/align_r.svg",
      },
      {
        name: "ALIGNC",
        label: "Align center",
        icon: "/assets/img/icons/align_c.svg",
      },
      {
        name: "ALIGNT",
        label: "Align top",
        icon: "/assets/img/icons/align_t.svg",
      },
      {
        name: "ALIGNB",
        label: "Align bottom",
        icon: "/assets/img/icons/align_b.svg",
      },
    ],
  },

  {
    label: "Bring to ...",
    icon: "/assets/img/icons/bring_front_icn.svg",
    btns: [
      {
        name: "BRINGTOFRONT",
        label: "Bring to front",
        icon: "/assets/img/icons/bring_front_icn.svg",
      },
      {
        name: "SENDTOBACK",
        label: "Send to back",
        icon: "/assets/img/icons/send_back_icn.svg",
      },
    ],
  },
]

const defSt = {
  transition: "all .2s ease",
}
const transSt = {
  entering: {opacity: 0},
  entered: {opacity: 1},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
